export default __webpack_public_path__ + "static/media/bg_purple_top.9604726d.png";